import { useQuery } from 'react-query';
import { GetCommunityTags } from 'services/apiServices';
import { Errors, TCommunityTagsResult } from 'types/ApiServicesTypes';

export default function useGetCommunityTags() {
  const objQuery = useQuery<TCommunityTagsResult, Errors>(
    ['GetCommunityTags'],
    async () => {
      return await GetCommunityTags();
    },
  );
  return objQuery;
} 